import type { Work } from "@/mocks/movies";
import WorkCard from "@/components/feature/WorkCard";
import { CardSkeleton, EmptyState } from "@/components/feature/WorkStates";

interface WorkGridProps {
  works: Work[];
  loading?: boolean;
  skeletonCount?: number;
  emptyTitle?: string;
  emptyDescription?: string;
  emptyActionLabel?: string;
  onEmptyAction?: () => void;
  columns?: 4 | 5;
}

export default function WorkGrid({
  works,
  loading = false,
  skeletonCount = 6,
  emptyTitle = "暂无相关内容",
  emptyDescription = "换个条件试试，或者稍后再来看看吧。",
  emptyActionLabel,
  onEmptyAction,
  columns = 5,
}: WorkGridProps) {
  const gridClass =
    columns === 4
      ? "grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4"
      : "grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5";

  return (
    <div className={gridClass}>
      {loading ? (
        <CardSkeleton count={skeletonCount} />
      ) : works.length === 0 ? (
        <EmptyState
          title={emptyTitle}
          description={emptyDescription}
          actionLabel={emptyActionLabel}
          onAction={onEmptyAction}
        />
      ) : (
        works.map((work) => <WorkCard key={work.id} work={work} />)
      )}
    </div>
  );
}